const searchWordToastMsg = {
  /**
   *  [검색 키워드 리스트] 리스트 요청하기
   */
  GET_SEARCH_WORD_LIST_REQUEST_SUCCESS: '검색 키워드 리스트 요청하기 성공',
  GET_SEARCH_WORD_LIST_REQUEST_ERROR: '검색 키워드 리스트 요청하기 실패',

  /**
   *  [검색 키워드 리스트] 엑셀 다운로드 요청하기
   */
  GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '검색 키워드 리스트 엑셀 다운로드 요청하기 성공',
  GET_SEARCH_WORD_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '검색 키워드 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  검색 키워드 상세 요청하기
   */
  GET_SEARCH_WORD_DETAIL_REQUEST_SUCCESS: '검색 키워드 상세 요청하기 성공',
  GET_SEARCH_WORD_DETAIL_REQUEST_ERROR: '검색 키워드 상세 요청하기 실패',

  /**
   *  키워드 체크하기
   */
  CHECK_KEYWORD_REQUEST_ERROR: '키워드 체크하기 실패',

  /**
   *  검색 키워드 등록하기
   */
  CREATE_SEARCH_WORD_REQUEST_SUCCESS: '검색 키워드 등록하기 성공',
  CREATE_SEARCH_WORD_REQUEST_ERROR: '검색 키워드 등록하기 실패',

  /**
   *  검색 키워드 편집하기
   */
  EDIT_SEARCH_WORD_REQUEST_SUCCESS: '검색 키워드 편집하기 성공',
  EDIT_SEARCH_WORD_REQUEST_ERROR: '검색 키워드 편집하기 실패',

  /**
   *  검색 키워드 삭제 요청하기
   */
  DELETE_SEARCH_WORD_REQUEST_SUCCESS: '검색 키워드 삭제 요청하기 성공',
  DELETE_SEARCH_WORD_REQUEST_ERROR: '검색 키워드 삭제 요청하기 실패',

  /**
   *  연관 키워드 리스트 요청하기
   */
  GET_RELATED_SEARCH_WORD_LIST_REQUEST_ERROR: '연관 키워드 리스트 요청하기 실패',
};

export default searchWordToastMsg;
